import React, { useState, useRef, useEffect } from 'react';
import { Routes, Route, Link, Navigate, useLocation } from "react-router-dom";

import { Line } from 'react-chartjs-2';

import TradingAccountInformation from "./pages/TradingAccountInformation";
import TradingInformationSubmitted from "./pages/TradingInformationSubmitted";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  TimeScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  CategoryScale
} from 'chart.js';
import 'chartjs-adapter-date-fns';
import './App.css';
import AuthPage from "./pages/AuthPage";
import SignIn from "./pages/SignIn";
import ProtectedRoute from "./components/ProtectedRoute";
import NavBar from "./components/NavBar";
import { useAuth } from "./pages/AuthContext";

ChartJS.register(
  LineElement,
  PointElement,
  TimeScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  CategoryScale
);

/* --------------------------- Trading Account Information --------------------------- */



/* --------------------- Reusable Coin + Chart Block --------------------- */
function CoinAndChart({ chartRef, data, options, downloadFilename, image, title }) {
  return (
    <section
      style={{
        maxWidth: 1000,
        margin: "0 auto 24px",
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: 24
      }}
    >
      {/* Coin panel */}
      <div
        style={{
          background: "#111",
          color: "#ffd700",
          padding: 24,
          borderRadius: 8,
          minHeight: 220,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        {/* Uniform coin size */}
        <div
          style={{
            width: 370,
            height: 370,
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#000"
          }}
        >
          <img
            src={image}
            alt={title}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover"
            }}
          />
        </div>
      </div>

      {/* Chart panel */}
      <div
        style={{
          background: "#fff",
          padding: 24,
          borderRadius: 8,
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)"
        }}
      >
        <h3 style={{ marginTop: 0 }}>{title}</h3>
        <div style={{ height: 320 }}>
          <Line ref={chartRef} data={data} options={{ ...options, maintainAspectRatio: false }} />
        </div>
      </div>
    </section>
  );
}


/* -------------------------- Dashboard -------------------------- */
                 function DashboardContent() {
          const [aiPortfolio, setAiPortfolio] = useState(null);
          const [copperPortfolio, setCopperPortfolio] = useState(null);
          const [uraniumPortfolio, setUraniumPortfolio] = useState(null);
          const [error, setError] = useState(null);
          const [loading, setLoading] = useState(true);
          const Location = useLocation();
          const equityRef1 = useRef(null);
          const equityRef2 = useRef(null);
          const equityRef3 = useRef(null);

     useEffect(() => {
       setLoading(true);
       setError(null);

    Promise.all([
      fetch(`${process.env.REACT_APP_API_URL}/api/portfolio/ai`).then((r) => {
        if (!r.ok) throw new Error(`AI HTTP ${r.status}`);
        return r.json();
      }),
      fetch(`${process.env.REACT_APP_API_URL}/api/portfolio/copper`).then((r) => {
        if (!r.ok) throw new Error(`Copper HTTP ${r.status}`);
        return r.json();
      }),
      fetch(`${process.env.REACT_APP_API_URL}/api/portfolio/uranium`).then((r) => {
        if (!r.ok) throw new Error(`Uranium HTTP ${r.status}`);
        return r.json();
      })
    ])
      .then(([aiData, copperData, uraniumData]) => {
        console.log('AI portfolio:', aiData);
        console.log('Copper portfolio:', copperData);
        console.log('Uranium portfolio:', uraniumData);

        setAiPortfolio(aiData);
        setCopperPortfolio(copperData);
        setUraniumPortfolio(uraniumData);

        setError(null);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Failed to load one or more portfolios:', err);
        setError('Could not load portfolio data.');
        setLoading(false);
      });
  }, []);

        const makeEquityData = (portfolio) => {
          if (!portfolio) return null;
          return {
          labels: portfolio.timestamps,
          datasets: [
        {
          label: 'Equity',
          data: portfolio.equity,
          borderColor: '#222',
          borderWidth: 1,
          fill: false
        }
      ]
    };
  };

       const timeAxisOptions = {
       scales: {
       x: { type: 'time', time: { unit: 'day' }, title: { display: true, text: 'Date' } },
        y: { beginAtZero: false, title: { display: true, text: 'Value' } }
    },
        responsive: true,
        plugins: { legend: { display: false } }
  };

        const aiEquityData = makeEquityData(aiPortfolio);
        const copperEquityData = makeEquityData(copperPortfolio);
        const uraniumEquityData = makeEquityData(uraniumPortfolio);
        const allLoaded = aiEquityData && copperEquityData && uraniumEquityData;

     return (
    <>
      <section
        style={{
          maxWidth: 1000,
          margin: '24px auto',
          background: '#fff',
          padding: 24,
          borderRadius: 8,
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
        }}
      >
        <h2 style={{ marginTop: 0, marginBottom: 8 }}>Dashboard</h2>
        <p style={{ fontSize: 18, color: '#444' }}>
          Track your assets with real-time analytics and historical data. Click the blue crystal to complete trading account information. Upon submitting trade account information your account will be granted access to funding, as well as purchasing fractional shares of a given spectra coin at the current market price.
        </p>

        {loading && (
          <p style={{ marginTop: 12, color: '#888' }}>Loading portfolio data…</p>
        )}
        {!loading && error && (
          <p style={{ marginTop: 12, color: 'red' }}>{error}</p>
        )}
      </section>

      {/* Only show charts once all three portfolios are loaded */}
      {allLoaded && (
        <>
          <CoinAndChart
            chartRef={equityRef1}
            data={aiEquityData}
            options={timeAxisOptions}
            downloadFilename="ai-fund.png"
            image="/ai.png"
            title="AI Fund Performance"
          />

          <CoinAndChart
            chartRef={equityRef2}
            data={copperEquityData}
            options={timeAxisOptions}
            downloadFilename="copper-fund.png"
            image="/copper.png"
            title="Copper Fund Performance"
          />

          <CoinAndChart
            chartRef={equityRef3}
            data={uraniumEquityData}
            options={timeAxisOptions}
            downloadFilename="uranium-fund.png"
            image="/uranium.png"
            title="Uranium Fund Performance"
          />
        </>
      )}
    </>
  );
}

/* --------------------------- App Wrapper --------------------------- */
                      export default function App() {
  
      // spectraUser in localStorage is written by AuthContext.login() as a JSON
      // object ({ username, account_id }) - read it the same way here instead of
      // keeping a separate, incompatible copy of "who's logged in".
      const { user } = useAuth();
      const username = user?.username || "Guest";
      const location = useLocation();

      // Second layer of defense against the bfcache: if a signed-out user
      // hits back/forward and the browser restores this page from cache
      // instead of re-running React on load, force them back to sign-in.
      useEffect(() => {
        const handlePageShow = () => {
          if (!localStorage.getItem("spectraUser")) {
            window.location.replace("/signin");
          }
        };
        window.addEventListener("pageshow", handlePageShow);
        return () => window.removeEventListener("pageshow", handlePageShow);
      }, []);

              return (

      <div style={{ background: "#f2f7ff", minHeight: "100vh", fontFamily: "Arial" }}>

         {!["/", "/signin"].includes(location.pathname.toLowerCase()) && (
        <NavBar username={username} />
     )}
          
        <Routes>

           {/* Public */}

        <Route path="/" element={<AuthPage />} />

        <Route
  path="/SignIn"
  element={<SignIn />}
/>

        {/* Protected */}

       <Route
          path="/Dashboard"
          element={
         <ProtectedRoute>
         <DashboardContent />
        </ProtectedRoute>
      }
      />

       <Route
          path="/TradingAccountInformation"
          element={
         <ProtectedRoute>
         <TradingAccountInformation />
         </ProtectedRoute>
      }
      />

         <Route
           path="/TradingAccountInformationSubmitted"
           element={
          <ProtectedRoute>
          <TradingInformationSubmitted />
          </ProtectedRoute>
      }
      />

        </Routes> 
      </div>
    );
   }
